import { t } from "../../i18n";
import { Sparkles } from "lucide-react";
import { asRecord, stringValue } from "./ToolResultView.utils";
import { ArtifactResult } from "../artifacts/ArtifactResult";
import { GenericResult } from "./GenericResult";

export function GeneratedActivityResult({ result }: { result: unknown }) {
  const values = asRecord(result);
  const generatedArtifacts = Array.isArray(values?.attachments)
    ? values.attachments.flatMap((item) => {
        const artifact = asRecord(asRecord(item)?.artifact);
        return artifact ? [artifact] : [];
      })
    : [];
  if (!generatedArtifacts.length) return <GenericResult value={result} />;
  return (
    <div className="space-y-2">
      <div className="flex items-center gap-2 px-1 text-xs font-semibold text-lumen-800 dark:text-lumen-200">
        <Sparkles size={14} /> {t("Generated artifacts")}
      </div>
      {generatedArtifacts.map((artifact) => (
        <ArtifactResult
          key={stringValue(artifact.id) || stringValue(artifact.name)}
          result={{ operation: "create", artifact }}
        />
      ))}
    </div>
  );
}
